import { useEffect } from 'react';
import { getLocation } from './helper';

import * as routeNames from '../../routes/routeName'

import Ably from 'ably';

export const TodayDispenseDeliveredByAnotherDriverAblyHelper = ({
    apiKey,
    deliveryDriverDeliveredDispense,
    pharmacyId,
    driverID,
    pId,
    routeName,
    location,
    setPatientID,
    setDeliveryDoneByAnotherDriver,
    dispatch,
    removeTodayDispenePatientById,
    setOpenIndex,
    setPId,
    setCordinate
}) => {


    useEffect(() => {
        getLocation(setCordinate)
    }, [])


    useEffect(() => {
        const ably = new Ably.Realtime({ key: apiKey });
        const channel = ably.channels.get(deliveryDriverDeliveredDispense);

        channel.subscribe(`delivered-dispense-${pharmacyId}`, (message) => {
            if (message?.name === `delivered-dispense-${pharmacyId}` && location.pathname.startsWith(routeName.DRIVER_ROUTE_TODAY)) {
                if (message?.data?.auth_driver_id !== driverID) {
                    setPatientID(message?.data?.patient_id);

                    if (pId === message?.data?.patient_id) {
                        setDeliveryDoneByAnotherDriver(true);
                        setTimeout(() => {
                            setDeliveryDoneByAnotherDriver(false);
                        }, 5000);
                        dispatch(removeTodayDispenePatientById(message?.data?.patient_id));
                        setPId(null);
                        setPatientID(null);
                        setOpenIndex(null);

                    } else {
                        dispatch(removeTodayDispenePatientById(message?.data?.patient_id));
                        setOpenIndex(null);
                        setPId(null);
                        setPatientID(null);
                    }
                }
            }
        });

        return () => {
            if (ably.connection.state === 'connected') {
                ably.close();
            }
        };
    }, [pId, pharmacyId]);

    return null;
};

export const PendingDispenseDeliveredByAnotherDriverAblyHelper = ({
    apiKey,
    deliveryDriverDeliveredDispense,
    pharmacyId,
    driverID,
    pId,
    setPatientID,
    setDeliveryDoneByAnotherDriver,
    dispatch,
    removePatientById,
    setOpenIndex,
    setPId,
    setCordinate
}) => {


    useEffect(() => {
        getLocation(setCordinate)
    }, [])


    useEffect(() => {
        const ably = new Ably.Realtime({ key: apiKey });
        const channel = ably.channels.get(deliveryDriverDeliveredDispense);

        channel.subscribe(`delivered-dispense-${pharmacyId}`, (message) => {
            if (message?.name === `delivered-dispense-${pharmacyId}`) {
                if (message?.data?.auth_driver_id !== driverID) {
                    setPatientID(message?.data?.patient_id)

                    if (pId === message?.data?.patient_id) {
                        setDeliveryDoneByAnotherDriver(true)
                        setTimeout(() => {
                            setDeliveryDoneByAnotherDriver(false)
                        }, 5000);
                        dispatch(removePatientById(message?.data?.patient_id));
                        setPId(null)
                        setPatientID(null)
                        setOpenIndex(null)

                    } else {
                        dispatch(removePatientById(message?.data?.patient_id));
                        setOpenIndex(null)
                        setPId(null)
                        setPatientID(null)
                    }
                }
            }
        })
        return () => {
            if (ably.connection.state === 'connected') {
                ably.close();
            }
        }
    }, [pId, pharmacyId]);


    return null;
};


export const SearchPatientListDeliveredByAnotherDriverAblyHelper = ({
    apiKey,
    deliveryDriverDeliveredDispense,
    pharmacyId,
    dispatch,
    setCordinate,
    setLoading,
    patientId,
    removePatientById,
    onDeliveredElsewhere
}) => {

    useEffect(() => {
        getLocation(setCordinate)
    }, [])

    useEffect(() => {

		const ably = new Ably.Realtime({ key: apiKey });
		const channel = ably.channels.get(deliveryDriverDeliveredDispense);

		channel.subscribe(`delivered-dispense-${pharmacyId}`, (message) => {
			if (message?.name === `delivered-dispense-${pharmacyId}`) {
				if (message?.data?.patient_id === patientId) {
					if (typeof setLoading === 'function') {
						setLoading(true)
					}
					if (typeof onDeliveredElsewhere === 'function') {
						onDeliveredElsewhere(message)
					} else {
						dispatch(removePatientById(message?.data?.patient_id))
					}
				}
			}
		})

		return () => {
			if (ably.connection.state === 'connected') {
				ably.close();
			}
		}
	}, [patientId, pharmacyId])

    return null;
};

const STATUS_STYLES = {
    red: { backgroundColor: 'rgba(220, 38, 38, 0.1)', color: '#b91c1c' },
    green: { backgroundColor: 'rgba(22, 163, 74, 0.1)', color: '#15803d' },
    yellow: { backgroundColor: 'rgba(202, 138, 4, 0.1)', color: '#a16207' },
};

export const getStatusSpan = (status, bgColor, textColor) => (
    <span
        className="px-2 py-1.5 text-sm rounded-md w-auto flex justify-center items-center"
        style={STATUS_STYLES[bgColor] || STATUS_STYLES[textColor] || STATUS_STYLES.yellow}
    >
        {status}
    </span>
);
